import { LimboLiveBetsColumns } from '../../games/limbo/limboCore/constants';
import { MinesLiveBetsColumns } from '../../games/mines/minesCore/constants';
import { DiceLiveBetsColumns } from '../../games/dice/diceCore/constants';
import { HiloLiveBetsColumns } from '../../games/hilo/hiloCore/constants';
import { KenoLiveBetsColumns } from '../../games/keno/kenoCore/constants';
import { TowerLiveBetsColumns } from '../../games/tower/towerCore/constants';
import { AlternativeDiceLiveBetsColumns } from '../../games/alternativeDice/alternativeDiceCore/constants';
import { WheelLiveBetsColumns } from '../../games/wheel/wheelCore/constants';
import { CoinFlipLiveBetsColumns } from '../../games/coinFlip/coinFlipCore/constants';
import { FishingLiveBetsColumns } from '../../games/fishing/fishingCore/constants';
import { BlackJackLiveBetsColumns } from '../../games/blackjack/blackJackCore/constants';
import { BaccaratLiveBetsColumns } from '../../games/baccarat/baccaratCore/constants';
import { FootballLiveBetsColumns } from '../../games/football/footballCore/constants';
import { CrashLiveBetsColumns } from '../../games/crash/crashCore/constants/betsColumns';
import { DriftLiveBetsColumns } from '../../games/drift/driftCore/constants/betsColumns';
import { RouletteLiveBetsColumns } from '../../games/roulette/rouletteCore/constants/tableRows';
import { PlinkoLiveBetsColumns } from '../../games/plinko/plinkoCore/constants/tableRowInfo';
import { DoubleDiceLiveBetsColumns } from '../../games/doubleDice/doubleDiceCore/constants';
import { Limbo10LiveBetsColumns } from '../../games/limbo10/limbo10Core/constants';
import { FastTradeLiveBetsColumns } from '../../games/fastTrade/fastTradeCore/constants';
import { HandBlackJackBetsColumns } from '../../games/handBlackjack/handBlackjackCore/constants';
import { GameIds } from './gameIds';
import { PowerOfGodsLiveBetsColumns } from '../../games/powerOfGods/powerOfGodsCore/constants/globalConstants';

export const LiveBetsColumnByGame = {
  [GameIds.Limbo]: LimboLiveBetsColumns,
  [GameIds.Mines]: MinesLiveBetsColumns,
  [GameIds.Dice]: DiceLiveBetsColumns,
  [GameIds.Hilo]: HiloLiveBetsColumns,
  [GameIds.AlternativeDice]: AlternativeDiceLiveBetsColumns,
  [GameIds.Keno]: KenoLiveBetsColumns,
  [GameIds.Wheel]: WheelLiveBetsColumns,
  [GameIds.CoinFlip]: CoinFlipLiveBetsColumns,
  [GameIds.Crash]: CrashLiveBetsColumns,
  [GameIds.Fishing]: FishingLiveBetsColumns,
  [GameIds.BlackJack]: BlackJackLiveBetsColumns,
  [GameIds.Baccarat]: BaccaratLiveBetsColumns,
  [GameIds.Football]: FootballLiveBetsColumns,
  [GameIds.Drift]: DriftLiveBetsColumns,
  [GameIds.Plinko]: PlinkoLiveBetsColumns,
  [GameIds.Roulette]: RouletteLiveBetsColumns,
  [GameIds.DoubleDice]: DoubleDiceLiveBetsColumns,
  [GameIds.Limbo10]: Limbo10LiveBetsColumns,
  [GameIds.FastTrade]: FastTradeLiveBetsColumns,
  [GameIds.HandBlackJack]: HandBlackJackBetsColumns,
  [GameIds.Tower]: TowerLiveBetsColumns,
  [GameIds.PowerOfGods]: PowerOfGodsLiveBetsColumns,
};
